import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FaQuoteLeft } from "react-icons/fa";

const UseCaseHighlight = () => {
  const { t } = useTranslation();

  return (
    <section className="relative bg-gray-50 py-24 px-6 overflow-hidden border-t">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center relative z-10">
        {/* Left Image with red overlay */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="relative"
        >
          <div className="absolute inset-0 bg-primary/50 rounded-xl z-10 mix-blend-multiply"></div>
          <img
            src="/assets/images/pool.png"
            alt={t("usecase.imageAlt")}
            className="w-full h-auto rounded-xl shadow-lg relative z-0 object-cover"
          />
        </motion.div>

        {/* Right Content */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-2xl font-extrabold text-gray-900 leading-snug mb-6">
            {t("usecase.title")}
            <span className="block text-primary mt-1">{t("usecase.subtitle")}</span>
          </h2>

          <p className="text-gray-600 text-base md:text-md mb-6">
            {t("usecase.description")}
          </p>

          <ul className="space-y-3 mb-8 text-sm md:text-base text-gray-700">
            <li>✓ {t("usecase.bullets.0")}</li>
            <li>✓ {t("usecase.bullets.1")}</li>
            <li>✓ {t("usecase.bullets.2")}</li>
            <li>✓ {t("usecase.bullets.3")}</li>
          </ul>

          <Link
            to="/use-cases"
            className="inline-block bg-primary text-white px-6 py-3 rounded-full font-semibold hover:bg-primary/90 transition"
          >
            {t("usecase.cta")}
          </Link>

          {/* Testimonial Block */}
          <div className="mt-10 bg-gray-50 p-6 rounded-lg shadow border border-gray-100">
            <div className="flex items-start gap-3">
              <FaQuoteLeft className="text-primary mt-1" />
              <div>
                <p className="text-sm text-gray-700 italic mb-2">
                  {t("usecase.testimonial.quote")}
                </p>
                <h4 className="font-bold text-gray-900 text-sm">
                  {t("usecase.testimonial.name")}
                </h4>
                <span className="text-xs text-gray-500">
                  {t("usecase.testimonial.role")}
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Optional background visual */}
      <div className="absolute -bottom-20 -right-20 w-[400px] h-[400px] bg-primary/10 rounded-full blur-3xl z-0 pointer-events-none"></div>
    </section>
  );
};

export default UseCaseHighlight;
